/*
  NOTICE: The following document was adaped from Ricardo's older endpoint backend data manipulation
  TESTE
*/

import { I18n } from "react-redux-i18n";

//Returns the datastructure exactly as it was at the old API point
export function manipulateInsights(
  insights,
  myChargers,
  myEvs,
  evsIOwn,
  userId,
  fetchMine,
  myGroups,
  myFleets,
  myInfrastructure
) {
  const myC = getSessionOnMyChargers(
    myEvs,
    myFleets,
    userId,
    fetchMine,
    myChargers,
    insights,
    myGroups,
    myInfrastructure
  );
  const myE = getMySessions(myEvs, insights, userId, fetchMine, myGroups, myFleets);
  const myR = getMyRating(myChargers);

  let ins = {};

  if (myE !== -1) {
    ins.myEvs = myE;
  }

  if (myC !== -1) {
    ins.myChargers = myC;
  } else {
    ins.myChargers = {
      chargers: listOfChargers(myChargers),
      income: 0,
      totalCO2Saved: 0,
      totalChargingTime: 0,
      totalEnergy: 0,
      totalSessions: 0,
    };
  }

  if (myR !== -1) {
    ins.myRating = myR;
  }

  return ins;
}

export function manipulateFilteredInsights(
  insights,
  myChargers,
  myEvs,
  evsIOwn,
  driverId,
  fetchMine,
  myGroups,
  myFleets,
  myInfrastructure
) {
  const myC = getSessionOnMyChargers(
    myEvs,
    myFleets,
    driverId,
    fetchMine,
    myChargers,
    insights,
    myGroups,
    myInfrastructure
  );
  const myE = getMySessionsFiltered(evsIOwn, insights, driverId, fetchMine, myGroups, myFleets);
  const myR = getMyRating(myChargers);

  let ins = {};

  if (myE !== -1) {
    ins.myEvs = myE;
  }

  if (myC !== -1) {
    ins.myChargers = myC;
  } else {
    ins.myChargers = {
      chargers: listOfChargers(myChargers),
      income: 0,
      totalCO2Saved: 0,
      totalChargingTime: 0,
      totalEnergy: 0,
      totalSessions: 0,
    };
  }

  if (myR !== -1) {
    ins.myRating = myR;
  }

  return ins;
}

function getMySessionsFiltered(evs, insights, userId, fetchMine, myGroups, myFleets) {
  const myEvs = getMyFilteredEvs(evs, userId, fetchMine);
  const myChargingSessions = getMyFilteringChargingSessions(userId, insights);

  /*if (myChargingSessions.length == 0 || insights.length == 0) {
    return -1;
  }*/

  let totalChargingTime = 0;
  let totalSessions = 0;
  let totalCost = 0;
  let totalEnergy = 0;
  let totalCO2Saved = 0;

  myChargingSessions.map(insights => {
    const found = myEvs.indexOf(
      myEvs.find(
        ev =>
          String(ev._id) === String(insights.sessions.evId) &&
          String(userId) === String(insights.sessions.userId)
      )
    );

    if (found >= 0) {
      totalSessions += 1;
      myEvs[found].sessions += 1;
      var timeCharged = 0;

      if (typeof insights.sessions.timeCharged === "undefined") {
        totalChargingTime += 0;
        myEvs[found].totalChargingTime += 0;
        timeCharged = 0;
      } else {
        totalChargingTime += insights.sessions.timeCharged;
        myEvs[found].totalChargingTime += insights.sessions.timeCharged / 3600;
        timeCharged = insights.sessions.timeCharged;
      }

      if (typeof insights.sessions.totalPrice === "undefined") {
        totalCost += 0;
        myEvs[found].totalSpend += 0;
      } else {
        totalCost += insights.sessions.totalPrice.excl_vat;
        myEvs[found].totalSpend += insights.sessions.totalPrice.excl_vat;
      }

      var energy;

      if (typeof insights.sessions.totalPower === "undefined") {
        totalEnergy += 0;
        myEvs[found].totalEnergy += 0;
        energy = 0;
      } else {
        totalEnergy += insights.sessions.totalPower;
        myEvs[found].totalEnergy += insights.sessions.totalPower / 1000;
        energy = insights.sessions.totalPower;
      }

      var charger;

      if (myEvs[found].chargerUsed.length === 0) {
        charger = {
          hwId: insights.sessions.hwId,
          cont: 1,
        };
        myEvs[found].chargerUsed.push(charger);
      } else {
        const index = myEvs[found].chargerUsed.indexOf(
          myEvs[found].chargerUsed.find(
            charger => String(charger.hwId) === String(insights.sessions.hwId)
          )
        );

        if (index >= 0) {
          myEvs[found].chargerUsed[index].cont += 1;
        } else {
          charger = {
            hwId: insights.sessions.hwId,
            cont: 1,
          };
          myEvs[found].chargerUsed.push(charger);
        }
      }

      if (typeof insights.sessions.CO2Saved === "undefined") {
        totalCO2Saved += 0;
        myEvs[found].totalCO2Saved += 0;
      } else {
        totalCO2Saved += insights.sessions.CO2Saved;
        myEvs[found].totalCO2Saved += insights.sessions.CO2Saved;
      }

      let location;

      if (typeof insights.charger.address !== "undefined") {
        location = insights.charger.address;
      } else {
        location = [];
      }

      let user;

      if (typeof insights.user !== "undefined") {
        user = insights.user;
      } else {
        user = [];
      }

      let network;

      if (typeof insights.charger.network !== "undefined") {
        network = insights.charger.network;
      } else {
        network = null;
      }

      let spent;

      if (typeof insights.sessions.totalPrice !== "undefined") {
        spent = insights.sessions.totalPrice.excl_vat;
      } else {
        spent = null;
      }

      let plug;

      if (typeof insights.charger.plugs !== "undefined") {
        plug = insights.charger.plugs;
      } else {
        plug = [];
      }

      let groupId;
      let groupName;

      for (let i = 0; i < myGroups.length; i++) {
        const grp = myGroups[i];
        for (let j = 0; j < grp.listOfUsers.length; j++) {
          const usr = grp.listOfUsers[j];
          if (usr.userId === user._id) {
            groupId = grp._id;
            groupName = grp.name;

            i = myGroups.length;
            break;
          }
        }
      }

      let fleetId = null;
      let fleetName = null;

      for (let i = 0; i < myFleets.length; i++) {
        const flt = myFleets[i];
        for (let j = 0; j < flt.listEvs.length; j++) {
          const ev = flt.listEvs[j];
          if (ev.evId === myEvs[found]._id) {
            fleetId = flt._id;
            fleetName = flt.name;

            i = myFleets.length;
            break;
          }
        }
      }

      const stat = {
        day: insights.sessions.startDate,
        energy: energy / 1000,
        timeCharged: timeCharged / 3600,
        card: null,
        location: location,
        user: user,
        network: network,
        spent: spent,
        plug: plug,
        hwId: insights.sessions.hwId,
        groupId: groupId,
        groupName: groupName,
        fleetId: fleetId,
        fleetName: fleetName,
        evId: myEvs[found]._id,
        evName: myEvs[found].licensePlate,
      };

      myEvs[found].statistics.push(stat);
    }
    return null;
  });

  myEvs.map(ev => {
    if (ev.sessions !== 0) {
      ev.chargerUsed.sort((a, b) => (a.cont < b.cont ? 1 : b.cont < a.cont ? -1 : 0));
      const favouriteCharger = getCharger(ev.chargerUsed[0].hwId, myChargingSessions);
      ev.averageChargingTimeSession = ev.totalChargingTime / ev.sessions;
      ev.averageEnergyChargedSession = ev.totalEnergy / ev.sessions;
      ev.favouriteCharger = favouriteCharger;
      delete ev.chargerUsed;
    }
    return null;
  });

  const listEvs = {
    totalChargingTime: totalChargingTime / 3600,
    totalSessions,
    totalCost,
    totalEnergy: totalEnergy / 1000,
    totalCO2Saved,
    evs: myEvs,
  };

  return listEvs;
}

function getMyChargingSessions(userId, insights) {
  return insights.filter(insight => String(insight.sessions.userId) === String(userId));
}

function getMyFilteringChargingSessions(driverId, insights) {
  return insights.filter(
    insight =>
      String(insight.sessions.userId) === String(driverId) &&
      String(insight.sessions.evId) !== String(-1)
  );
}

function getChargingSessions(insights, chargers) {
  return [].concat.apply(
    [],
    chargers.map(charger => {
      return insights.filter(insight => String(insight.sessions.hwId) === String(charger.hwId));
    })
  );
}

function listOfChargers(insights) {
  const newList = [];

  insights.map(insight => {
    const newPlugsUsed = [];

    insight.plugs.map(plug => {
      newPlugsUsed.push({
        plugId: plug.plugId,
        cont: 0,
      });
      return null;
    });

    const newCharger = {
      _id: insight._id,
      name: insight.name,
      hwId: insight.hwId,
      address: insight.address,
      infrastructure: insight.infrastructure,
      numberOfPlugs: insight.plugs.length,
      defaultImage: insight.defaultImage,
      rating: insight.rating,
      myChargersSessions: 0,
      totalEnergy: 0,
      totalChargingTime: 0,
      totalIncime: 0,
      totalCO2Saved: 0,
      averageChargingTimeSession: 0,
      averageEnergyChargedSession: 0,
      mostUsedPlug: {},
      plugsUsed: newPlugsUsed,
      plugs: insight.plugs,
      statistics: [],
    };

    newList.push(newCharger);
    return null;
  });

  return newList;
}

function getMostUsedPlug(plug, listPlugs) {
  const found = listPlugs.find(newPlug => String(newPlug.plugId) === String(plug.plugId));

  if (typeof found !== "undefined") {
    return {
      plugId: found.plugId,
      connectorType: found.connectorType,
    };
  }
  return {};
}

function getSessionOnMyChargers(
  evs,
  myFleets,
  userId,
  fetchMine,
  chargers,
  insights,
  myGroups,
  myInfrastructure
) {
  const myChargers = chargers.filter(charger => charger.plugs.length !== 0);

  if (myChargers.length === 0 || insights.length === 0) {
    return -1;
  }

  const newListChargers = listOfChargers(myChargers);

  const myChargersSessions = getChargingSessions(insights, chargers);

  if (myChargersSessions.length === 0) {
    var totalChargingTime = 0;
    var totalSessions = myChargersSessions.length;
    var income = 0;
    var totalEnergy = 0;
    var totalCO2Saved = 0;

    newListChargers.map(charger => {
      charger.plugsUsed.sort((a, b) => (a.cont < b.cont ? 1 : b.cont < a.cont ? -1 : 0));

      const mostUsedPlug = getMostUsedPlug(charger.plugsUsed[0], charger.plugs);

      if (charger.myChargersSessions !== 0) {
        charger.averageChargingTimeSession = charger.totalChargingTime / charger.myChargersSessions;
        charger.averageEnergyChargedSession = charger.totalEnergy / charger.myChargersSessions;
      } else {
        charger.averageChargingTimeSession = 0;
        charger.averageEnergyChargedSession = 0;
      }
      charger.mostUsedPlug = mostUsedPlug;
      delete charger.plugs;
      delete charger.plugsUsed;
      return charger;
    });

    var listMyChargers = {
      totalChargingTime,
      totalSessions,
      income,
      totalEnergy,
      totalCO2Saved,
      chargers: newListChargers,
    };
    return listMyChargers;
  } else {
    totalChargingTime = 0;
    totalSessions = myChargersSessions.length;
    income = 0;
    totalEnergy = 0;
    totalCO2Saved = 0;

    myChargersSessions.map(ses => {
      const session = ses.sessions;

      if (typeof session.timeCharged === "undefined") {
        totalChargingTime += 0;
      } else {
        totalChargingTime += session.timeCharged / 3600;
      }

      if (typeof session.totalPrice === "undefined") {
        income += 0;
      } else {
        income += session.totalPrice.excl_vat;
      }

      if (typeof session.totalPower === "undefined") {
        totalEnergy += 0;
      } else {
        totalEnergy += session.totalPower / 1000;
      }

      if (typeof session.CO2Saved === "undefined") {
        totalCO2Saved += 0;
      } else {
        totalCO2Saved += Number(session.CO2Saved);
      }

      const found = newListChargers.indexOf(
        newListChargers.find(charger => String(charger.hwId) === String(session.hwId))
      );

      if (found >= 0) {
        newListChargers[found].myChargersSessions += 1;

        var energy;

        if (typeof session.totalPower === "undefined") {
          newListChargers[found].totalEnergy += 0;
          energy = 0;
        } else {
          newListChargers[found].totalEnergy += session.totalPower / 1000;
          energy = session.totalPower;
        }

        var timeCharged;

        if (typeof session.timeCharged === "undefined") {
          newListChargers[found].totalChargingTime += 0;
          timeCharged = 0;
        } else {
          newListChargers[found].totalChargingTime += session.timeCharged / 3600;
          timeCharged = session.timeCharged;
        }

        if (typeof session.totalPrice === "undefined") {
          newListChargers[found].totalIncime += 0;
        } else {
          newListChargers[found].totalIncime += session.totalPrice.excl_vat;
        }

        let location;

        if (typeof ses.charger.address !== "undefined") {
          location = ses.charger.address;
        } else {
          location = [];
        }

        let user;

        if (typeof ses.user !== "undefined") {
          user = ses.user;
        } else {
          user = [];
        }

        let network;

        if (typeof ses.charger.network !== "undefined") {
          network = ses.charger.network;
        } else {
          network = null;
        }

        let spent;

        if (typeof ses.sessions.totalPrice !== "undefined") {
          spent = ses.sessions.totalPrice.excl_vat;
        } else {
          spent = null;
        }

        let plug;

        if (typeof ses.charger.plugs !== "undefined") {
          plug = ses.charger.plugs;
        } else {
          plug = [];
        }

        let groupId = null;
        let groupName = null;

        for (let i = 0; i < myGroups.length; i++) {
          const grp = myGroups[i];
          for (let j = 0; j < grp.listOfUsers.length; j++) {
            const usr = grp.listOfUsers[j];
            if (usr.userId === user._id) {
              groupId = grp._id;
              groupName = grp.name;

              i = myGroups.length;
              break;
            }
          }
        }

        let fleetId = null;
        let fleetName = null;

        for (let i = 0; i < myFleets.length; i++) {
          const flt = myFleets[i];
          for (let j = 0; j < flt.listEvs.length; j++) {
            const ev = flt.listEvs[j];

            if (ev.evId === ses.ev._id) {
              fleetId = flt._id;
              fleetName = flt.name;

              i = myFleets.length;
              break;
            }
          }
        }

        const stat = {
          day: session.startDate,
          energy: energy / 1000,
          CO2Saved: session.CO2Saved,
          timeCharged: timeCharged / 3600,
          card: null,
          location: location,
          user: user,
          network: network,
          spent: spent,
          plug: plug,
          infrastructure: myInfrastructure.find(infr => infr._id === ses.charger.infrastructure),
          hwId: ses.sessions.hwId,
          groupId: groupId,
          groupName: groupName,
          fleetId: fleetId,
          fleetName: fleetName,
          evId: ses.ev._id,
          evName: ses.ev.licensePlate,
        };

        newListChargers[found].statistics.push(stat);
      }
      return null;
    });

    newListChargers.map(charger => {
      charger.plugsUsed.sort((a, b) => (a.cont < b.cont ? 1 : b.cont < a.cont ? -1 : 0));

      const mostUsedPlug = getMostUsedPlug(charger.plugsUsed[0], charger.plugs);

      if (charger.myChargersSessions !== 0) {
        charger.averageChargingTimeSession = charger.totalChargingTime / charger.myChargersSessions;
        charger.averageEnergyChargedSession = charger.totalEnergy / charger.myChargersSessions;
      } else {
        charger.averageChargingTimeSession = 0;
        charger.averageEnergyChargedSession = 0;
      }
      charger.mostUsedPlug = mostUsedPlug;
      delete charger.plugs;
      delete charger.plugsUsed;
      return null;
    });

    listMyChargers = {
      totalChargingTime,
      totalSessions,
      income,
      totalEnergy,
      totalCO2Saved,
      chargers: newListChargers,
    };

    /*     console.log("listMyChargers: ", listMyChargers)

  listMyChargers.chargers.forEach(charger => {
    charger.statistics.forEach(stat => {
      console.log("CO2Saved: ", stat.CO2Saved)
    });
  }); */

    return listMyChargers;
  }
}

function getMyRating(myChargers) {
  if (myChargers.length === 0) {
    return -1;
  }

  let rating = 0;
  let numChargers = 0;

  myChargers.map(charger => {
    if (charger.numberOfSessions !== 0) {
      rating += charger.rating;
      numChargers += 1;
    }
    return null;
  });

  if (numChargers !== 0) {
    return rating / numChargers;
  }

  return -1;
}

function getMySessions(evs, insights, userId, fetchMine, myGroups, myFleets) {
  const myEvs = getMyEvs(evs);
  const myChargingSessions = fetchMine ? insights : getMyChargingSessions(userId, insights);

  /*if (myChargingSessions.length == 0 || insights.length == 0) {
    return -1;
  }*/

  let totalChargingTime = 0;
  let totalSessions = 0;
  let totalCost = 0;
  let totalEnergy = 0;
  let totalCO2Saved = 0;
  let usedChargersCount = [];
  let myLastUsedCharger = [];

  myChargingSessions.map(insights => {
    const found = myEvs.indexOf(
      myEvs.find(ev => String(ev._id) === String(insights.sessions.evId))
    );

    if (found >= 0) {
      myLastUsedCharger.push(insights);

      const idx = usedChargersCount.indexOf(
        usedChargersCount.find(charger => charger._id === insights.charger._id)
      );

      if (idx >= 0) {
        usedChargersCount[idx].counter += 1;
      } else {
        const charger = insights.charger;
        charger.counter = 0;
        usedChargersCount.push(charger);
      }

      totalSessions += 1;
      myEvs[found].sessions += 1;
      var timeCharged = 0;

      if (typeof insights.sessions.timeCharged === "undefined") {
        totalChargingTime += 0;
        myEvs[found].totalChargingTime += 0;
        timeCharged = 0;
      } else {
        totalChargingTime += insights.sessions.timeCharged;
        myEvs[found].totalChargingTime += insights.sessions.timeCharged / 3600;
        timeCharged = insights.sessions.timeCharged;
      }

      if (typeof insights.sessions.totalPrice === "undefined") {
        totalCost += 0;
        myEvs[found].totalSpend += 0;
      } else {
        totalCost += insights.sessions.totalPrice.excl_vat;
        myEvs[found].totalSpend += insights.sessions.totalPrice.excl_vat;
      }

      var energy;

      if (typeof insights.sessions.totalPower === "undefined") {
        totalEnergy += 0;
        myEvs[found].totalEnergy += 0;
        energy = 0;
      } else {
        totalEnergy += insights.sessions.totalPower;
        myEvs[found].totalEnergy += insights.sessions.totalPower / 1000;
        energy = insights.sessions.totalPower;
      }

      var charger;

      if (myEvs[found].chargerUsed.length === 0) {
        charger = {
          hwId: insights.sessions.hwId,
          cont: 1,
        };
        myEvs[found].chargerUsed.push(charger);
      } else {
        const index = myEvs[found].chargerUsed.indexOf(
          myEvs[found].chargerUsed.find(
            charger => String(charger.hwId) === String(insights.sessions.hwId)
          )
        );

        if (index >= 0) {
          myEvs[found].chargerUsed[index].cont += 1;
        } else {
          charger = {
            hwId: insights.sessions.hwId,
            cont: 1,
          };
          myEvs[found].chargerUsed.push(charger);
        }
      }

      if (typeof insights.sessions.CO2Saved === "undefined") {
        totalCO2Saved += 0;
        myEvs[found].totalCO2Saved += 0;
      } else {
        totalCO2Saved += Number(insights.sessions.CO2Saved);
        myEvs[found].totalCO2Saved += Number(insights.sessions.CO2Saved);
      }

      let location;

      if (typeof insights.charger.address !== "undefined") {
        location = insights.charger.address;
      } else {
        location = [];
      }

      let user;

      if (typeof insights.user !== "undefined") {
        user = insights.user;
      } else {
        user = [];
      }

      let network;

      if (typeof insights.charger.network !== "undefined") {
        network = insights.charger.network;
      } else {
        network = null;
      }

      let spent;

      if (typeof insights.sessions.totalPrice !== "undefined") {
        spent = insights.sessions.totalPrice.excl_vat;
      } else {
        spent = null;
      }

      let plug;

      if (typeof insights.charger.plugs !== "undefined") {
        plug = insights.charger.plugs;
      } else {
        plug = [];
      }

      let groupId;
      let groupName;

      for (let i = 0; i < myGroups.length; i++) {
        const grp = myGroups[i];
        for (let j = 0; j < grp.listOfUsers.length; j++) {
          const usr = grp.listOfUsers[j];
          if (usr.userId === user._id) {
            groupId = grp._id;
            groupName = grp.name;

            i = myGroups.length;
            break;
          }
        }
      }

      let fleetId = null;
      let fleetName = null;

      for (let i = 0; i < myFleets.length; i++) {
        const flt = myFleets[i];
        for (let j = 0; j < flt.listEvs.length; j++) {
          const ev = flt.listEvs[j];
          if (ev.evId === myEvs[found]._id) {
            fleetId = flt._id;
            fleetName = flt.name;

            i = myFleets.length;
            break;
          }
        }
      }

      const stat = {
        day: insights.sessions.startDate,
        energy: energy / 1000,
        timeCharged: timeCharged / 3600,
        CO2Saved: insights.sessions.CO2Saved,
        card: null,
        location: location,
        user: user,
        network: network,
        spent: spent,
        plug: plug,
        hwId: insights.sessions.hwId,
        groupId: groupId,
        groupName: groupName,
        fleetId: fleetId,
        fleetName: fleetName,
        evId: myEvs[found]._id,
        evName: myEvs[found].licensePlate,
      };

      myEvs[found].statistics.push(stat);
    }
    return null;
  });

  usedChargersCount.sort(function (a, b) {
    return a.counter > b.counter;
  });

  let myLastUsedC;
  let mylastUsedSession;

  if (myLastUsedCharger.length > 0) {
    mylastUsedSession = myLastUsedCharger.sort(function (b, a) {
      return new Date(a.sessions.stopDate) - new Date(b.sessions.stopDate);
    })[0];
    myLastUsedC = mylastUsedSession.charger;
  }

  myEvs.map(ev => {
    if (ev.sessions !== 0) {
      ev.chargerUsed.sort((a, b) => (a.cont < b.cont ? 1 : b.cont < a.cont ? -1 : 0));
      const favouriteCharger = getCharger(ev.chargerUsed[0].hwId, myChargingSessions);
      ev.averageChargingTimeSession = ev.totalChargingTime / ev.sessions;
      ev.averageEnergyChargedSession = ev.totalEnergy / ev.sessions;
      ev.favouriteCharger = favouriteCharger;
      delete ev.chargerUsed;
    }
    return null;
  });

  const listEvs = {
    totalChargingTime: totalChargingTime / 3600,
    totalSessions,
    totalCost,
    totalEnergy: totalEnergy / 1000,
    totalCO2Saved,
    evs: myEvs,
    mostUsedCPByMe: usedChargersCount && usedChargersCount.length > 0 ? usedChargersCount[0] : null,
    myLastUsedCharger: myLastUsedC ? myLastUsedC : null,
  };

  return listEvs;
}

function getCharger(hwId, sessions) {
  const session = sessions.find(session => String(session.charger.hwId) === String(hwId));

  if (session)
    return {
      _id: session.charger._id,
      name: session.charger.name,
      address: session.charger.address,
      hwId: session.charger.hwId,
      geometry: session.charger.geometry,
      rating: session.charger.rating,
    };
  else return {};
}

function getMyEvs(evsFound) {
  const myEvs = [];
  const evEmpty = {
    _id: -1,
    primaryEV: false,
    brand: "",
    model: "",
    licensePlate: "",
    imageContent: "",
    sessions: 0,
    totalEnergy: 0,
    totalChargingTime: 0,
    totalSpend: 0,
    totalCO2Saved: 0,
    averageChargingTimeSession: 0,
    averageEnergyChargedSession: 0,
    favouriteCharger: {},
    chargerUsed: [],
    statistics: [],
  };

  if (typeof evsFound === "undefined") {
    myEvs.push(evEmpty);
  } else {
    evsFound.map(ev => {
      myEvs.push({
        _id: ev._id,
        primaryEV: ev.primaryEV,
        brand: ev.brand,
        model: ev.model,
        licensePlate: ev.licensePlate,
        imageContent: ev.imageContent,
        sessions: 0,
        totalEnergy: 0,
        totalChargingTime: 0,
        totalCO2Saved: 0,
        totalSpend: 0,
        averageChargingTimeSession: 0,
        averageEnergyChargedSession: 0,
        favouriteCharger: {},
        chargerUsed: [],
        statistics: [],
      });
      return null;
    });
  }
  return myEvs;
}

function getMyFilteredEvs(evsFound, userId, fetchMine) {
  const myEvs = [];
  const evEmpty = {
    _id: -1,
    primaryEV: false,
    brand: "",
    model: "",
    licensePlate: "",
    listOfDrivers: [],
    imageContent: "",
    sessions: 0,
    totalEnergy: 0,
    totalChargingTime: 0,
    totalSpend: 0,
    totalCO2Saved: 0,
    averageChargingTimeSession: 0,
    averageEnergyChargedSession: 0,
    favouriteCharger: {},
    chargerUsed: [],
    statistics: [],
  };

  if (typeof evsFound === "undefined") {
    myEvs.push(evEmpty);
  } else {
    evsFound.map(ev => {
      myEvs.push({
        _id: ev._id,
        primaryEV: ev.primaryEV,
        brand: ev.brand,
        model: ev.model,
        licensePlate: ev.licensePlate,
        listOfDrivers: ev.listOfDrivers,
        imageContent: ev.imageContent,
        sessions: 0,
        totalEnergy: 0,
        totalChargingTime: 0,
        totalSpend: 0,
        averageChargingTimeSession: 0,
        averageEnergyChargedSession: 0,
        favouriteCharger: {},
        chargerUsed: [],
        statistics: [],
      });
      return null;
    });
  }

  if (fetchMine) {
    return myEvs;
  } else {
    return myEvs.filter(ev => {
      return ev.listOfDrivers.find(driver => String(driver.userId) === String(userId));
    });
  }
}

export function groupDataBy(data, groupBy, withVat) {
  let groupedBy = {};
  if (groupBy === "user") {
    data.myEvs.evs.map(ev => {
      ev.statistics.map(stat => {
        if (stat.user && stat.user.hasOwnProperty("_id")) {
          if (groupedBy.hasOwnProperty(stat.user._id)) {
            groupedBy[stat.user._id] = Object.assign({}, groupedBy[stat.user._id], {
              statistics: [
                ...groupedBy[stat.user._id].statistics,
                Object.assign({}, stat, {
                  evName: ev.licensePlate,
                }),
              ],
              totalCO2Saved: groupedBy[stat.user._id].totalCO2Saved + stat.CO2Saved,
              totalChargingTime: groupedBy[stat.user._id].totalChargingTime + stat.timeCharged,
              totalCost: groupedBy[stat.user._id].totalCost + stat.spent,
              totalEnergy: groupedBy[stat.user._id].totalEnergy + stat.energy,
              totalSessions: groupedBy[stat.user._id].totalSessions + 1,
            });
          } else {
            groupedBy[stat.user._id] = {
              name: stat.user.name,
              statistics: [Object.assign({}, stat, { evName: ev.licensePlate })],
              totalCO2Saved: stat.CO2Saved,
              totalChargingTime: stat.timeCharged,
              totalCost: stat.spent,
              totalEnergy: stat.energy,
              totalSessions: 1,
            };
          }
        }
        return null;
      });
      return null;
    });
  } else if (groupBy === "network") {
    data.myEvs.evs.map(ev => {
      ev.statistics.map(stat => {
        if (groupedBy.hasOwnProperty(stat.network)) {
          groupedBy[stat.network] = Object.assign({}, groupedBy[stat.network], {
            statistics: [
              ...groupedBy[stat.network].statistics,
              Object.assign({}, stat, { evName: ev.licensePlate }),
            ],
            totalCO2Saved: groupedBy[stat.network].totalCO2Saved + stat.CO2Saved,
            totalChargingTime: groupedBy[stat.network].totalChargingTime + stat.timeCharged,
            totalCost: groupedBy[stat.network].totalCost + stat.spent,
            totalEnergy: groupedBy[stat.network].totalEnergy + stat.energy,
            totalSessions: groupedBy[stat.network].totalSessions + 1,
          });
        } else {
          groupedBy[stat.network] = {
            statistics: [Object.assign({}, stat, { evName: ev.licensePlate })],
            totalCO2Saved: stat.CO2Saved,
            totalChargingTime: stat.timeCharged,
            totalCost: stat.spent,
            totalEnergy: stat.energy,
            totalSessions: 1,
          };
        }
        return null;
      });
      return null;
    });
  } else if (groupBy === "infrastructure") {
    data.myChargers.chargers.forEach(charger => {
      const infrastructure = data.myInfrastructure.find(
        infr => infr._id === charger.infrastructure
      );
      if (infrastructure) {
        charger.statistics.forEach(stat => {
          if (groupedBy.hasOwnProperty(infrastructure._id)) {
            groupedBy[infrastructure._id] = Object.assign({}, groupedBy[infrastructure._id], {
              statistics: [
                ...groupedBy[infrastructure._id].statistics,
                Object.assign({}, stat, { chargerName: charger.name }),
              ],
              totalCO2Saved: groupedBy[infrastructure._id].totalCO2Saved + stat.CO2Saved,
              totalChargingTime: groupedBy[infrastructure._id].totalChargingTime + stat.timeCharged,
              totalCost: groupedBy[infrastructure._id].totalCost + stat.spent,
              totalEnergy: groupedBy[infrastructure._id].totalEnergy + stat.energy,
              totalSessions: groupedBy[infrastructure._id].totalSessions + 1,
            });
          } else {
            groupedBy[infrastructure._id] = {
              name: infrastructure.name,
              statistics: [Object.assign({}, stat, { chargerName: charger.name })],
              totalCO2Saved: stat.CO2Saved,
              totalChargingTime: stat.timeCharged,
              totalCost: stat.spent,
              totalEnergy: stat.energy,
              totalSessions: 1,
            };
          }
        });
      }
    });
  } else if (groupBy === "fleet") {
    data.myEvs.evs.map(ev => {
      ev.statistics.map(stat => {
        if (stat.fleetId && stat.hasOwnProperty("fleetId")) {
          if (groupedBy.hasOwnProperty(stat.fleetId)) {
            groupedBy[stat.fleetId] = Object.assign({}, groupedBy[stat.fleetId], {
              statistics: [
                ...groupedBy[stat.fleetId].statistics,
                Object.assign({}, stat, {
                  evName: ev.licensePlate,
                }),
              ],
              totalCO2Saved: groupedBy[stat.fleetId].totalCO2Saved + stat.CO2Saved,
              totalChargingTime: groupedBy[stat.fleetId].totalChargingTime + stat.timeCharged,
              totalCost: groupedBy[stat.fleetId].totalCost + stat.spent,
              totalEnergy: groupedBy[stat.fleetId].totalEnergy + stat.energy,
              totalSessions: groupedBy[stat.fleetId].totalSessions + 1,
            });
          } else {
            groupedBy[stat.fleetId] = {
              name: stat.fleetName,
              statistics: [Object.assign({}, stat, { evName: ev.licensePlate })],
              totalCO2Saved: stat.CO2Saved,
              totalChargingTime: stat.timeCharged,
              totalCost: stat.spent,
              totalEnergy: stat.energy,
              totalSessions: 1,
            };
          }
        }
        return null;
      });
      return null;
    });
  } else if (groupBy === "charger") {
    data.myChargers.chargers.forEach(charger => {
      charger.statistics.forEach(stat => {
        if (groupedBy.hasOwnProperty(charger._id)) {
          groupedBy[charger._id] = Object.assign({}, groupedBy[charger._id], {
            statistics: [
              ...groupedBy[charger._id].statistics,
              Object.assign({}, stat, { chargerName: charger.name }),
            ],
            totalCO2Saved: groupedBy[charger._id].totalCO2Saved + stat.CO2Saved,
            totalChargingTime: groupedBy[charger._id].totalChargingTime + stat.timeCharged,
            totalCost: groupedBy[charger._id].totalCost + stat.spent,
            totalEnergy: groupedBy[charger._id].totalEnergy + stat.energy,
            totalSessions: groupedBy[charger._id].totalSessions + 1,
          });
        } else {
          groupedBy[charger._id] = {
            name: charger.name,
            address: charger.address,
            statistics: [Object.assign({}, stat, { chargerName: charger.name })],
            totalCO2Saved: stat.CO2Saved,
            totalChargingTime: stat.timeCharged,
            totalCost: stat.spent,
            totalEnergy: stat.energy,
            totalSessions: 1,
          };
        }
      });
    });
  } else if (groupBy === "none") {
    let totalCO2Emitted = 0;
    let totalChargingTime = 0;
    let totalCost = 0;
    let totalEnergy = 0;
    let totalSessions = 0;
    data.forEach(stat => {
      totalCO2Emitted += stat.CO2Saved || 0;
      totalChargingTime += stat.timeCharged || 0;
      totalCost += (stat.totalPrice && stat.totalPrice[withVat ? "incl_vat" : "excl_vat"]) || 0;
      totalEnergy += stat.totalPower || 0;
      totalSessions += 1;
    });

    return Object.assign(
      {},
      { data },
      {
        groupedBy: {
          totalCO2Emitted,
          totalChargingTime,
          totalCost,
          totalEnergy,
          totalSessions,
        },
      }
    );
  }

  return Object.assign({}, data, { groupedBy });
}
